/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DatabaseEntriesCopyResult
 */
export interface DatabaseEntriesCopyResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof DatabaseEntriesCopyResult
     */
    copiedEntryIds?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof DatabaseEntriesCopyResult
     */
    copiedFiles?: number;
    /**
     * Namen der Quellfelder ohne Gegenstueck im Ziel.
     * @type {Array<string>}
     * @memberof DatabaseEntriesCopyResult
     */
    unmatchedFields?: Array<string>;
    /**
     * Auswahlwerte, die das Ziel nicht kennt, als "Feldname: Wert".
     * @type {Array<string>}
     * @memberof DatabaseEntriesCopyResult
     */
    droppedValues?: Array<string>;
}

/**
 * Check if a given object implements the DatabaseEntriesCopyResult interface.
 */
export function instanceOfDatabaseEntriesCopyResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseEntriesCopyResultFromJSON(json: any): DatabaseEntriesCopyResult {
    return DatabaseEntriesCopyResultFromJSONTyped(json, false);
}

export function DatabaseEntriesCopyResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseEntriesCopyResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'copiedEntryIds': !exists(json, 'copiedEntryIds') ? undefined : json['copiedEntryIds'],
        'copiedFiles': !exists(json, 'copiedFiles') ? undefined : json['copiedFiles'],
        'unmatchedFields': !exists(json, 'unmatchedFields') ? undefined : json['unmatchedFields'],
        'droppedValues': !exists(json, 'droppedValues') ? undefined : json['droppedValues'],
    };
}

export function DatabaseEntriesCopyResultToJSON(value?: DatabaseEntriesCopyResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'copiedEntryIds': value.copiedEntryIds,
        'copiedFiles': value.copiedFiles,
        'unmatchedFields': value.unmatchedFields,
        'droppedValues': value.droppedValues,
    };
}

